'use strict';

angular.module('completeAir.version.version-controller', ['ui.router'])

    .controller('languageCtrl', ['$scope', '$translate', 'defaultErrorMessageResolver',
        function($scope, $translate, defaultErrorMessageResolver) {

            $scope.changeLanguage = function(lang){

                var langUpper = "";

                switch (lang){
                    case "es":
                        langUpper = "CO"
                        break;
                    case "en":
                        langUpper = "US"
                        break;
                }

                $translate.use(lang);
                defaultErrorMessageResolver.setCulture(lang + '-' + langUpper);
            }
    }]);

